module.exports = __webpack_public_path__ + "img/8.7dd033a3.jpg";